import { keyApp, useStore } from "hooks/useStore";
import UserDto from "types/UserDto";

export default function useCurrentUser() {
  const { id, firstName, lastName, email, role, twoFactorAuth, accountIds } =
    useStore((store) => store[keyApp].currentUser) as UserDto;

  return {
    id,
    firstName,
    lastName,
    email,
    role,
    twoFactorAuth,
    accountIds,
  };
}
